
export const sortCriteria = [
  { field: "Sorter utvalg", order: "", key: "" },
  { field: "Pris (lav - høy)", order: "asc", key: "price" },
  { field: "Pris (høy - lav)", order: "desc", key: "price" },
  { field: "Alfabetisk (A - Å)", order: "asc", key: "title" },
  { field: "Alfabetisk (Å - A)", order: "desc", key: "title" },
];
export const selectedSort = $state({ sort: sortCriteria[0] });
